
import { defineComponent, nextTick, ref } from "vue";
import MapPanel from "./mapPanel.vue";
import CharacterPanel from "./characterPanel.vue";
import BattlePanel, { BattlePanelRefs } from "./battlePanel.vue";
import { EwgDialogRefs } from "@/types/components";
export default defineComponent({
  components: {
    MapPanel,
    CharacterPanel,
    BattlePanel
  },
  setup() {
    const dangerFlag = ref(false);
    const handleDanger = (flag: boolean) => {
      dangerFlag.value = flag;
    };
    const BattleDialog = ref<EwgDialogRefs>();
    const BattlePanel = ref<BattlePanelRefs>();
    const closeBattleModal = () => {
      BattleDialog.value?.close();
    };
    const startBattle = (id: any) => {
      BattleDialog.value?.open();
      nextTick(() => {
        BattlePanel.value?.load(id);
      });
    };
    const startBattleByData = (monsterData: any, option: any) => {
      BattleDialog.value?.open();
      nextTick(() => {
        BattlePanel.value?.battleStart(monsterData, option);
      });
    };
    return {
      dangerFlag,
      handleDanger,
      BattleDialog,
      BattlePanel,
      startBattle,
      closeBattleModal,
      startBattleByData
    };
  }
});
